import React from "react";
import ReactDOM from "react-dom";
import "./css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { MainProvider } from "./context/main";

ReactDOM.render(
  <MainProvider>
    <BrowserRouter basename="/voip/portal">
      <App />
    </BrowserRouter>
  </MainProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
